// Estate types - legacy types for web package
// TODO: Align with server implementation when estate feature is implemented
export var EstateType;
(function (EstateType) {
    EstateType["PRINCIPAL_RESIDENCE"] = "principal_residence";
    EstateType["INVESTMENT"] = "investment";
    EstateType["VACATION"] = "vacation";
    EstateType["OTHER"] = "other";
})(EstateType || (EstateType = {}));
export var EstatePurpose;
(function (EstatePurpose) {
    EstatePurpose["FAMILY_USE"] = "family_use";
    EstatePurpose["PARTNER_USE"] = "partner_use";
    EstatePurpose["CHILDREN_USE"] = "children_use";
    EstatePurpose["INVESTMENT_ONLY"] = "investment_only";
    EstatePurpose["RENTAL_INCOME"] = "rental_income";
    EstatePurpose["PERSONAL_INVESTMENT"] = "personal_investment";
})(EstatePurpose || (EstatePurpose = {}));
